"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compose = void 0;

// eslint-disable-next-line @typescript-eslint/ban-types
var compose = function compose() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return fns.length === 0 ? function (x) {
    return x;
  } : fns.reduce(function (accFn, fn) {
    return function () {
      return accFn(fn.apply(void 0, arguments));
    };
  });
};

exports.compose = compose;